import { useState } from "react";

export function useAuthState() {
  const [auth, setAuth] = useState({
    govbr: { loading: false, error: "" },
    gsi: { loading: false, error: "" },
    sso: { loading: false, error: "" },
  });

  const setLoading = (provider: keyof typeof auth, loading: boolean) => {
    setAuth((prev) => ({
      ...prev,
      [provider]: {
        ...prev[provider],
        loading,
        error: loading ? "" : prev[provider].error,
      },
    }));
  };

  const setError = (provider: keyof typeof auth, error: string) => {
    setAuth((prev) => ({
      ...prev,
      [provider]: { ...prev[provider], error, loading: false },
    }));
  };

  const clearErrors = () => {
    setAuth({
      govbr: { loading: false, error: "" },
      gsi: { loading: false, error: "" },
      sso: { loading: false, error: "" },
    });
  };

  return {
    auth,
    setLoading,
    setError,
    clearErrors,
  };
}
